import { autocompleteLocationsQuery } from '../lib/graphql';

export function getAutocompleteLocations() {
  return async (dispatch, getState, { client }) => {
    try {
      const { data } = await client.query({
        query: autocompleteLocationsQuery,
        fetchPolicy: 'network-only'
      });
      
      return data?.autocompleteLocations || [];
      
    } catch (error) {
      console.error('Error fetching autocomplete locations:', error);
      return [];
    }
  };
}